<div *ngIf="isInProgress">
  <app-spinner></app-spinner>
</div>

<!-- Content Header -->
<section class="content-header">
  <div class="container-fluid">

    <!-- Slim Mobile Toolbar -->
    <div class="toolbar-row">
      <a routerLink="/" class="toolbar-btn">
        <i class="fas fa-home"></i>
      </a>

      <h5 class="toolbar-title mb-0">
        Vehicle List
      </h5>

      <button class="toolbar-btn" disabled>
        <i class="fas fa-car"></i>
      </button>
    </div>

    <!-- Filters -->
    <div class="row mb-3" *ngIf="this.stockAccessLevel==1 || this.stockAccessLevel==2 || this.stockAccessLevel==3">
      <div class="col-12">
        <div class="card shadow-sm rounded-lg">
          <div class="card-body">

            <div class="row">

              <!-- Location -->
              <div class="col-12 col-md-6 mb-2">
                <label class="font-weight-bold">Location</label>
                <select
                  name="locations"
                  class="form-control"
                  [(ngModel)]="selectedLocation"
                  (change)="onSelectChange($event.target)"
                >
                  <option value="">Select</option>
                  <option
                    [value]="location.id"
                    *ngFor="let location of locations"
                  >
                    {{ location.location_name }}
                  </option>
                </select>
              </div>

              <!-- Branch -->
              <div class="col-12 col-md-6 mb-2">
                <label class="font-weight-bold">Branch</label>
                <select
                  name="branches"
                  class="form-control"
                  [(ngModel)]="selectedBranch"
                  (change)="onSelectBranchChange($event.target)"
                >
                  <option value="">Select</option>
                  <option
                    [value]="branch.id"
                    *ngFor="let branch of branches"
                  >
                    {{ branch.branch_name }}
                  </option>
                </select>
              </div>

            </div>

          </div>
        </div>
      </div>
    </div>

    <!-- Search -->
    <div class="row mb-3">
      <div class="col-12">
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text bg-white border-success">
              <i class="fas fa-search"></i>
            </span>
          </div>

          <input
            type="text"
            class="form-control border-success"
            placeholder="Search"
            (input)="onSearchTextChange($event)"
          />
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Content -->
<section class="content">
  <div class="container-fluid">

    <!-- Alerts -->
    <div class="alert alert-danger" *ngIf="errorMessage">
      {{ errorMessage }}
    </div>

    <div class="alert alert-success" *ngIf="successMessage">
      {{ successMessage }}
    </div>

    <div class="alert alert-warning" *ngIf="warningMessage">
      {{ warningMessage }}
    </div>

    <div class="alert alert-info" *ngIf="infoMessage">
      {{ infoMessage }}
    </div>

    <!-- Vehicle Cards -->
    <div
      class="card shadow-sm rounded-lg mb-3"
      *ngFor="let vehicle of vehicles | searchVehicle: searchText | paginate: { itemsPerPage: 10, currentPage: page, totalItems: count }"
    >
    <a routerLink="/mobile/vehicle-details/{{vehicle.vehicle_id}}">
      <div class="card-body p-3">

        <div class="row align-items-center">

          <!-- Vehicle Image -->
          <div class="col-4 col-md-2 text-center">
            <img
              [src]="vehicle.main_photo || 'assets/no-photo.png'"
              class="img-fluid rounded"
              style="max-height:100px; object-fit:cover;"
            />
          </div>

          <!-- Vehicle Details -->
          <div class="col-8 col-md-10">

            <h4 class="text-danger mb-2 font-weight-bold text-uppercase">
              {{ vehicle.make }} {{ vehicle.model }}
            </h4>

            <h5 class="text-success mb-2">
              Chassis No.: {{ vehicle.chassis_no }}
            </h5>

            <p class="mb-1">
              <strong>Colour:</strong> {{ vehicle.colour }}
              &nbsp;&nbsp;
              <strong>Year:</strong> {{ vehicle.year }}
            </p>

            <small class="text-dark">
              Location: {{ vehicle.location_name }} - {{ vehicle.branch_name }}
            </small>

          </div>

        </div>

      </div>
    </a>
    </div>

    <!-- Pagination -->
    <pagination-controls
      (pageChange)="pageChangeEvent($event)">
    </pagination-controls>

  </div>
</section>
